import React from "react";
import request from "arcdynamic-request";
import { SELLERS } from "../../consts/tables";
import Dropdown from "../Dropdown/Dropdown";
import PropTypes from "prop-types";

const cloneDeep = require("lodash.clonedeep");
const limit = 1000;

class SelectSeller extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
    };
  }

  componentDidMount() {
    this.fetch(0);
  }

  fetch(offset) {
    request(arc.path.api, {
      service: "arcimedes",
      action: "open.datasource.table.Data.getData",
      params: [
        "code",
        SELLERS,
        {
          limit: {
            count: limit,
            offset: offset * limit,
          },
          column: [
            "ARCIMEDES_ROW_ID",
            "FIRST_NAME",
            "LAST_NAME",
            "COMPANY_NAME",
          ],
          filter: [
            {
              code: "DELETED",
              text: "",
              type: "null",
            },
          ],
          order: [
            {
              code: "FIRST_NAME",
              type: "asc",
            },
            {
              code: "LAST_NAME",
              type: "asc",
            },
            {
              code: "COMPANY_NAME",
              type: "asc",
            },
          ],
        },
      ],
    }).then((res) => {
      this.setState((prevState) => {
        const items = prevState.items.concat(res.data);
        return {
          items,
        };
      });
      if (res.data.length >= limit) {
        this.fetch(++offset);
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.newSeller !== nextProps.newSeller) {
      const items = cloneDeep(this.state.items);
      items.push(nextProps.newSeller);
      this.setState({ items });
    }
  }

  render() {
    const { items } = this.state;
    const {
      theme,
      value,
      valueKey,
      label,
      disabled,
      data,
      withAddNew,
      handleParentChange,
      addNewItem,
      deleted,
      viewMode,
      ...rest,
    } = this.props;

    return (
      <Dropdown
        theme={theme}
        optionsType="seller"
        optionKey="ARCIMEDES_ROW_ID"
        options={items}
        value={value}
        valueKey={valueKey}
        label={label}
        disabled={!items || disabled}
        data={data}
        withAddNew={withAddNew}
        handleParentChange={handleParentChange}
        addNewItem={addNewItem}
        deleted={deleted}
        viewMode={viewMode}
        {...rest}
      />
    );
  }
}

SelectSeller.propTypes = {
  theme: PropTypes.oneOf(["default", "white", "dark"]),
  value: PropTypes.string,
  valueKey: PropTypes.string.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  data: PropTypes.object,
  withAddNew: PropTypes.bool,
  handleParentChange: PropTypes.func.isRequired,
  viewMode: PropTypes.bool,
  addNewItem: PropTypes.func,
  deleted: PropTypes.bool,
  isFromProperty: PropTypes.bool,
};

export default SelectSeller;
